import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { View } from '@zhike/ti-ui';
import axios from 'axios';
import { createPromise } from 'utils/action';
import { Error } from '@zhike/ti-component';
import { get, isNaN } from 'lodash';
import * as apis from 'common/apis';
import Loading from 'components/loading';
import Test from 'components/report/test';
import BaseReport from './base_report';
import EvalutionReport from './evaluation_report';
import SeniorReport from './senior_report';
import styles from './styles';

const search = global.location.search; // eslint-disable-line
// type 用来区分不同版本的测评 （是否为完整版入学测评 isFull = true 是以前的写法）
const isFull = decodeURIComponent(search.match(new RegExp('[?#&]isFull=([^?#&]+)', 'i')) ? RegExp.$1 : '');
let type = decodeURIComponent(search.match(new RegExp('[?#&]type=([^?#&]+)', 'i')) ? RegExp.$1 : 0);
if (isNaN(type)) { type = 0; } else { type = type * 1; }; // eslint-disable-line
if (isFull === 'true') type = 1;

// 报告
export default class Report extends Component {
  // 参数
  static propTypes = {
    getReport: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    getUploadSignature: PropTypes.func.isRequired,
    postCorrectionImage: PropTypes.func.isRequired,
    postCorrection: PropTypes.func.isRequired,
    postMachinePigai: PropTypes.func.isRequired,
  };

  // 构造函数
  constructor(props) {
    super(props);
    this.state = {
      isCompatible: true,
      isLoad: false,
      report: {},
    };
  }

  // 加载
  async componentDidMount() {
    // 检测兼容性
    if (
      global.navigator.userAgent.match(/msie/i) ||
      global.ActiveXObject ||
      ('ActiveXObject') in global
    ) {
      this.setState({
        isCompatible: false,
      });
    }
    const { getReport, match } = this.props;
    const { exerciseId, questionId } = match.params;
    let { mode } = match.params;
    const data = await axios({
      url: apis.getExamId[1],
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        From: 1,
      },
      params: {
        exerciseId,
      },
    });
    let examId = get(data, 'data.data.id');
    // mode 为 question
    if (mode === 'question') { mode = 'base'; }
    if (mode === 'test') {
      global.document.title = `${examId === 56 ? '国际高中' : (examId === 2 ? 'IELTS' : 'TOEFL')}智能测评报告 - 智课`;
    }
    if (mode === 'test' && type === 1) { mode = 'full-test'; }
    if (type === 2) { examId = 2; }
    const report = await createPromise(getReport,
      {
        exerciseId,
        questionId,
        mode,
        examId,
        type,
      });
    this.setState({
      isLoad: true,
      report: mode.indexOf('test') === -1 ? get(report, 'data.questionBackup') : get(report, 'data'),
      duration: get(report, 'data.duration'),
    });
  }

  // 渲染
  render() {
    const { isCompatible, isLoad, report, duration } = this.state;
    const { match, getReport, getUploadSignature,
      postCorrectionImage, postCorrection, postMachinePigai } = this.props;
    const { mode } = match.params;
    const examId = get(report, 'examId');
    const renderProps = {
      match,
      getReport,
      getUploadSignature,
      postCorrectionImage,
      postCorrection,
      report,
      postMachinePigai,
      isFull: type === 1,
      duration,
    };
    return (
      <View className={styles.container} >
        {
          !isCompatible &&
          <Error match={{ params: { type: 'compatible' } }} />
        }
        {
          !isLoad && isCompatible &&
          <Loading text="正在加载数据，请稍候..." />
        }
        {
          isLoad && isCompatible && (mode === 'practice' || mode === 'question') && JSON.stringify(renderProps.report) !== '{}' &&
          <BaseReport {...renderProps} />
        }
        {
          isLoad && isCompatible && mode === 'test' && renderProps.report && JSON.stringify(renderProps.report) !== '{}' && examId !== 56 && type !== 2 &&
          <EvalutionReport {...renderProps} />
        }
        {
          isLoad && isCompatible && mode === 'test' && renderProps.report && JSON.stringify(renderProps.report) !== '{}' && examId === 56 &&
          <SeniorReport {...renderProps} />
        }
        {
          isLoad && isCompatible && mode === 'test' && renderProps.report && JSON.stringify(renderProps.report) !== '{}' && examId !== 56 && type === 2 &&
          <Test {...renderProps} />
        }
      </View>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/report/index.js